import { useEffect } from 'react';
import { PostMessageType } from './modal/post-message-type';
import { PostMessageData } from './modal/post-message-data';
import { isNullOrUndefinedOrEmpty } from 'utils/utils';

const PREFIX = 'SYNCEE';

export const usePostMessage = <T>(key: PostMessageType, callback?: (data?: T) => void, modalId: string = null) => {
    const type = `${PREFIX}_${key}`;

    const postMessage = (data?: T) => {
        let element: Window = window;

        if (!isNullOrUndefinedOrEmpty(modalId)) {
            const iframe = document.getElementById(modalId) as HTMLIFrameElement;
            if (isNullOrUndefinedOrEmpty(iframe)) {
                element = iframe?.contentWindow;
            }
        }

        element.postMessage({ data, type } as PostMessageData<T>, location.origin);
    };

    useEffect((): VoidFunction => {
        if (!callback) return;

        function handleMessage(event: MessageEvent<PostMessageData<T>>) {
            if (event.data?.type === type) {
                callback(event.data.data);
            }
        }

        window.addEventListener('message', handleMessage);
        return (): void => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    return { postMessage };
};
